(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-chat-widget"]) return;
  try {
    
  (function () {
    'use strict';

    const MAX_HISTORY = 12;

    class AiChatWidget extends HTMLElement {
      connectedCallback() {
        this.toggleBtn = this.querySelector('[data-chat-toggle]');
        this.closeBtn = this.querySelector('[data-chat-close]');
        this.panel = this.querySelector('[data-chat-panel]');
        this.body = this.querySelector('.chat-body');
        this.welcome = this.querySelector('[data-chat-welcome]');
        this.form = this.querySelector('[data-chat-form]');
        this.input = this.querySelector('[data-chat-input]');
        this.log = this.querySelector('[data-chat-log]');

        this.systemPrompt = this.dataset.systemPrompt || '';
        this.apiKey = this.dataset.apiKey || '';
        this.model = this.dataset.model || 'openai/gpt-oss-120b';
        this.history = [];
        this.busy = false;

        this.toggleBtn.addEventListener('click', () => this.toggle());
        this.closeBtn.addEventListener('click', () => this.close());
        this.form.addEventListener('submit', (event) => this.onSubmit(event));

        this.querySelectorAll('[data-chat-quick-reply]').forEach((button) => {
          button.addEventListener('click', () => this.sendMessage(button.textContent.trim()));
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
        });

        window.addEventListener('nyf:ask-ai', (event) => {
          const question = event.detail && event.detail.question;
          if (!question) return;
          this.open();
          this.sendMessage(question);
        });
      }

      toggle() {
        if (this.classList.contains('is-open')) {
          this.close();
        } else {
          this.open();
        }
      }

      open() {
        this.classList.add('is-open');
        this.toggleBtn.setAttribute('aria-expanded', 'true');
        this.panel.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => this.input.focus());
      }

      close() {
        this.classList.remove('is-open');
        this.toggleBtn.setAttribute('aria-expanded', 'false');
        this.panel.setAttribute('aria-hidden', 'true');
      }

      addMessage(role, text) {
        const row = document.createElement('div');
        row.className = 'msg msg--' + role;
        row.textContent = text;
        this.log.appendChild(row);
        this.body.scrollTop = this.body.scrollHeight;
        return row;
      }

      onSubmit(event) {
        event.preventDefault();
        const text = this.input.value.trim();
        if (!text || this.busy) return;
        this.input.value = '';
        this.sendMessage(text);
      }

      async sendMessage(text) {
        if (!text || this.busy) return;

        this.welcome.classList.add('is-hidden');

        if (!this.apiKey) {
          this.addMessage('assistant', this.dataset.textNotConfigured);
          return;
        }

        this.addMessage('user', text);
        this.history.push({ role: 'user', content: text });
        this.busy = true;

        const pending = this.addMessage('assistant', this.dataset.textThinking);
        pending.classList.add('is-pending');

        try {
          const response = await fetch('https://api.groq.com/openai/v1/chat/completions', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + this.apiKey,
            },
            body: JSON.stringify({
              model: this.model,
              messages: [{ role: 'system', content: this.systemPrompt }, ...this.history],
              temperature: 0.4,
              max_tokens: 500,
              reasoning_effort: 'low',
              include_reasoning: false,
            }),
          });

          if (!response.ok) throw new Error('Groq request failed: ' + response.status);

          const data = await response.json();
          const reply = data.choices && data.choices[0] && data.choices[0].message && data.choices[0].message.content;

          pending.remove();

          if (reply) {
            this.addMessage('assistant', reply.trim());
            this.history.push({ role: 'assistant', content: reply.trim() });
            if (this.history.length > MAX_HISTORY) {
              this.history = this.history.slice(-MAX_HISTORY);
            }
          } else {
            this.addMessage('assistant', this.dataset.textError);
          }
        } catch (error) {
          pending.remove();
          this.addMessage('assistant', this.dataset.textError);
        } finally {
          this.busy = false;
        }
      }
    }

    if (!customElements.get('ai-chat-widget')) customElements.define('ai-chat-widget', AiChatWidget);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brew-club"] && !Shopify.designMode) return;
  try {
    
  class BrewClub extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';

      this.hero = this.closest('.brew-hero');
      this.stageEl = this.hero ? this.hero.querySelector('[data-gallery-stage]') : null;
      this.thumbRowEl = this.hero ? this.hero.querySelector('[data-gallery-thumb-row]') : null;
      this.thumbsEl = this.hero ? this.hero.querySelector('[data-gallery-thumbs]') : null;
      this.thumbPrevBtn = this.hero ? this.hero.querySelector('[data-thumb-prev]') : null;
      this.thumbNextBtn = this.hero ? this.hero.querySelector('[data-thumb-next]') : null;
      this.typeButtons = Array.from(this.querySelectorAll('[data-type]'));
      this.qtyHost = this.querySelector('[data-quantities]');
      this.planButtons = Array.from(this.querySelectorAll('[data-plan]'));
      this.variantInput = this.querySelector('[data-variant-input]');
      this.quantityInput = this.querySelector('[data-quantity-input]');
      this.planInput = this.querySelector('[data-plan-input]');
      this.priceEl = this.querySelector('[data-summary-price]');
      this.priceNoteEl = this.querySelector('[data-summary-note]');
      this.submitBtn = this.querySelector('[data-brew-submit]');
      this.currentPlans = {};
      this.currentMonths = null;
      this.pouchGallery = [];
      this.tinGallery = [];
      this.galleryAlt = '';

      this.typeButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.selectType(btn));
      });
      this.planButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.selectPlan(btn));
      });

      if (this.thumbPrevBtn) {
        this.thumbPrevBtn.addEventListener('click', () => this.scrollThumbs(-1));
      }
      if (this.thumbNextBtn) {
        this.thumbNextBtn.addEventListener('click', () => this.scrollThumbs(1));
      }
      if (this.thumbsEl) {
        this.thumbsEl.addEventListener('scroll', () => this.syncThumbNav(), { passive: true });
      }

      // Plan must be selected first: selecting a type/quantity renders and
      // prices pills against the currently chosen plan length.
      const initialPlan = this.planButtons.find((b) => b.classList.contains('is-on')) || this.planButtons[0];
      if (initialPlan) this.selectPlan(initialPlan);

      const initialType = this.typeButtons.find((b) => b.classList.contains('is-on')) || this.typeButtons[0];
      if (initialType) this.selectType(initialType);
    }

    selectType(btn) {
      this.typeButtons.forEach((b) => {
        const on = b === btn;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', String(on));
      });

      let variants = [];
      try {
        variants = JSON.parse(btn.dataset.variants || '[]');
      } catch (err) {
        variants = [];
      }

      let gallery = [];
      try {
        gallery = JSON.parse(btn.dataset.gallery || '[]');
      } catch (err) {
        gallery = [];
      }
      let tinGallery = [];
      try {
        tinGallery = JSON.parse(btn.dataset.galleryTin || '[]');
      } catch (err) {
        tinGallery = [];
      }
      this.pouchGallery = gallery;
      this.tinGallery = tinGallery;
      this.galleryAlt = btn.dataset.alt || '';
      this.renderQuantities(variants);
    }

    renderGallery(images, altText) {
      if (!this.stageEl || !this.thumbsEl) return;
      this.stageEl.replaceChildren();
      this.thumbsEl.replaceChildren();

      images.forEach((image, index) => {
        const figure = document.createElement('figure');
        figure.className = 'brew-hero-photo' + (index === 0 ? ' is-on' : '');
        figure.dataset.slide = String(index);

        const img = document.createElement('img');
        img.src = image.full;
        img.alt = altText;
        img.loading = index === 0 ? 'eager' : 'lazy';
        figure.appendChild(img);
        this.stageEl.appendChild(figure);
      });

      const showThumbs = images.length > 1;
      if (showThumbs) {
        images.forEach((image, index) => {
          const thumb = document.createElement('button');
          thumb.type = 'button';
          thumb.className = 'brew-hero-thumb' + (index === 0 ? ' is-on' : '');
          thumb.dataset.goto = String(index);
          thumb.setAttribute('aria-label', altText);

          const img = document.createElement('img');
          img.src = image.thumb;
          img.alt = '';
          img.loading = 'lazy';
          thumb.appendChild(img);

          thumb.addEventListener('click', () => this.gotoSlide(index));
          this.thumbsEl.appendChild(thumb);
        });
      }

      if (this.thumbRowEl) {
        this.thumbRowEl.hidden = !showThumbs;
      }
      this.thumbsEl.scrollLeft = 0;
      this.syncThumbNav();
    }

    scrollThumbs(dir) {
      if (!this.thumbsEl) return;
      const step = this.thumbsEl.clientWidth * 0.8;
      this.thumbsEl.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    syncThumbNav() {
      if (!this.thumbsEl) return;
      const maxScroll = this.thumbsEl.scrollWidth - this.thumbsEl.clientWidth;
      if (this.thumbPrevBtn) this.thumbPrevBtn.disabled = this.thumbsEl.scrollLeft <= 1;
      if (this.thumbNextBtn) this.thumbNextBtn.disabled = this.thumbsEl.scrollLeft >= maxScroll - 1;
    }

    gotoSlide(index) {
      if (!this.stageEl || !this.thumbsEl) return;
      this.stageEl.querySelectorAll('.brew-hero-photo').forEach((figure) => {
        figure.classList.toggle('is-on', Number(figure.dataset.slide) === index);
      });
      let activeThumb = null;
      this.thumbsEl.querySelectorAll('.brew-hero-thumb').forEach((thumb) => {
        const on = Number(thumb.dataset.goto) === index;
        thumb.classList.toggle('is-on', on);
        if (on) activeThumb = thumb;
      });
      if (activeThumb) {
        activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      }
    }

    renderQuantities(variants) {
      this.qtyHost.replaceChildren();

      variants.forEach((variant, index) => {
        const option = document.createElement('button');
        option.type = 'button';
        option.className = 'brew-pill' + (index === 0 ? ' is-on' : '');
        option.setAttribute('role', 'radio');
        option.setAttribute('aria-checked', String(index === 0));
        option.disabled = !variant.available;
        option.dataset.variantId = variant.id;
        option.dataset.variantTitle = variant.title || '';
        option.dataset.plans = JSON.stringify(variant.plans || {});
        option.textContent = variant.label;

        option.addEventListener('click', () => this.selectQuantity(option));
        this.qtyHost.appendChild(option);
      });

      const first = this.qtyHost.querySelector('.brew-pill');
      if (first) this.selectQuantity(first);
    }

    selectQuantity(btn) {
      Array.from(this.qtyHost.children).forEach((b) => {
        const on = b === btn;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', String(on));
      });
      this.variantInput.value = btn.dataset.variantId || '';
      this.submitBtn.disabled = btn.disabled || !btn.dataset.variantId;
      try {
        this.currentPlans = JSON.parse(btn.dataset.plans || '{}');
      } catch (err) {
        this.currentPlans = {};
      }
      const title = (btn.dataset.variantTitle || '').toLowerCase();
      const useTin = title.indexOf('30') !== -1 && this.tinGallery.length > 0;
      this.renderGallery(useTin ? this.tinGallery : this.pouchGallery, this.galleryAlt);
      this.updateSummary();
    }

    selectPlan(btn) {
      this.planButtons.forEach((b) => {
        const on = b === btn;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', String(on));
      });
      this.currentMonths = btn.dataset.months;
      this.planInput.value = this.currentMonths + ' months';
      if (this.quantityInput) this.quantityInput.value = this.currentMonths;
      if (this.priceNoteEl) this.priceNoteEl.textContent = btn.dataset.totalLabel || '';
      this.updateSummary();
    }

    updateSummary() {
      if (!this.priceEl) return;
      this.priceEl.textContent = this.currentPlans[this.currentMonths] || '-';
    }
  }

  if (!customElements.get('brew-club')) {
    customElements.define('brew-club', BrewClub);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  function bindFooterAcc() {
    const root = document.querySelector('[data-footer-acc]');
    if (!root) return;
    const items = root.querySelectorAll('details.foot-acc');
    const desktop = window.matchMedia('(min-width: 800px)');

    const sync = () => {
      items.forEach((item) => {
        if (desktop.matches) item.setAttribute('open', '');
        else item.removeAttribute('open');
      });
    };

    if (desktop.addEventListener) desktop.addEventListener('change', sync);
    else desktop.addListener(sync);
    sync();
  }

  bindFooterAcc();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journal-handbook"] && !Shopify.designMode) return;
  try {
    
  class HandbookCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dotsHost = this.querySelector('[data-dots]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      if (!this.track || this.slides.length < 1) return;

      if (this.slides.length < 2) {
        this.classList.add('is-single');
        return;
      }

      this.dots = this.slides.map((_, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'handbook-carousel__dot';
        btn.setAttribute('aria-label', String(i + 1));
        btn.addEventListener('click', () => this.go(i));
        this.dotsHost.appendChild(btn);
        return btn;
      });

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      window.addEventListener('resize', () => this.sync(), { passive: true });
      this.sync();
    }

    slideWidth() {
      const first = this.slides[0];
      if (!first) return 0;
      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    currentIndex() {
      const width = this.slideWidth();
      if (!width) return 0;
      return Math.round(this.track.scrollLeft / width);
    }

    maxIndex() {
      const width = this.slideWidth();
      if (!width) return 0;
      const extra = this.track.scrollWidth - this.track.clientWidth;
      return Math.max(0, Math.round(extra / width));
    }

    go(index) {
      const width = this.slideWidth();
      const next = Math.max(0, Math.min(this.maxIndex(), index));
      this.track.scrollTo({ left: next * width, behavior: 'smooth' });
    }

    step(dir) {
      this.go(this.currentIndex() + dir);
    }

    sync() {
      const index = this.currentIndex();
      const max = this.maxIndex();
      this.dots.forEach((dot, i) => dot.classList.toggle('is-on', i === index));
      if (this.prevBtn) this.prevBtn.disabled = index <= 0;
      if (this.nextBtn) this.nextBtn.disabled = index >= max;
    }
  }

  if (!customElements.get('handbook-carousel')) {
    customElements.define('handbook-carousel', HandbookCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landingpage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-landing]');
    if (!root) return;

    // FAQ accordion
    var faqButtons = root.querySelectorAll('button[aria-controls^="faq-"]');
    faqButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        faqButtons.forEach(function (b) {
          var isThis = b === btn;
          var show = isThis ? !open : false;
          b.setAttribute('aria-expanded', show ? 'true' : 'false');
          var panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) panel.hidden = !show;
          var wrap = b.querySelector('span');
          var icon = wrap && wrap.querySelector('img');
          if (wrap) {
            wrap.classList.toggle('bg-pink', show);
            wrap.classList.toggle('bg-white', !show);
          }
          if (icon) {
            var cur = icon.getAttribute('src');
            icon.setAttribute('src', show ? cur.replace('lp-plus', 'lp-minus') : cur.replace('lp-minus', 'lp-plus'));
          }
        });
      });
    });

    // Mobile carousels: dots <-> horizontal scroll
    root.querySelectorAll('button[aria-label^="Show "][aria-current], button[aria-label^="Go to item "]').forEach(function (btn) {
      var dots = btn.parentElement;
      var track = dots.previousElementSibling;
      if (!track || dots.dataset.bound) return;
      dots.dataset.bound = '1';
      var buttons = Array.prototype.slice.call(dots.querySelectorAll('button'));
      var setActive = function (i) {
        buttons.forEach(function (b, n) {
          var on = n === i;
          b.setAttribute('aria-current', on ? 'true' : 'false');
          b.classList.toggle('w-5', on);
          b.classList.toggle('w-2', !on);
        });
      };
      buttons.forEach(function (b, i) {
        b.addEventListener('click', function () {
          var slide = track.children[i];
          if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft - parseInt(getComputedStyle(track).scrollPaddingLeft || 0, 10), behavior: 'smooth' });
          setActive(i);
        });
      });
      track.addEventListener('scroll', function () {
        var best = 0, bestDist = Infinity;
        Array.prototype.forEach.call(track.children, function (c, i) {
          var d = Math.abs(c.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        setActive(best);
      }, { passive: true });
    });

    // Desktop gallery thumbnails -> main image
    root.querySelectorAll('button[aria-pressed]').forEach(function (btn) {
      var row = btn.parentElement;
      var main = row.previousElementSibling;
      if (!main || row.dataset.bound) return;
      row.dataset.bound = '1';
      var thumbs = Array.prototype.slice.call(row.querySelectorAll('button[aria-pressed]'));
      var mainImg = main.querySelector('img');
      var label = main.querySelector('span');
      var slides = root.querySelectorAll('[class*="snap-start"] > img');
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          var src = t.querySelector('img').getAttribute('src');
          if (mainImg) mainImg.setAttribute('src', src);
          if (label) label.textContent = t.getAttribute('aria-label').replace('Show ', '');
          thumbs.forEach(function (o) {
            var on = o === t;
            o.setAttribute('aria-pressed', on ? 'true' : 'false');
            o.classList.toggle('border-pink', on);
            o.classList.toggle('border-line-petal', !on);
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manufacture-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class ManufactureFilm extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        this.toggles = Array.from(this.querySelectorAll('[data-manufacture-toggle]'));
        this.autoplay = this.hasAttribute('data-autoplay');
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.labels = {
          play: this.getAttribute('data-label-play') || 'Play video',
          pause: this.getAttribute('data-label-pause') || 'Pause video'
        };

        this.silence();
        this.video.playsInline = true;

        this.onPlay = () => {
          this.silence();
          this.syncUi();
        };
        this.onPause = () => this.syncUi();
        this.onVolume = () => this.silence();
        this.video.addEventListener('play', this.onPlay);
        this.video.addEventListener('pause', this.onPause);
        this.video.addEventListener('volumechange', this.onVolume);

        this.toggles.forEach((btn) => {
          btn.addEventListener('click', (event) => {
            event.preventDefault();
            this.togglePlay();
          });
        });

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting && !this.video.paused) {
                this.video.pause();
              }
            });
          },
          { threshold: 0.2 }
        );
        this.observer.observe(this);
        this.syncUi();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (!this.video) return;
        this.video.removeEventListener('play', this.onPlay);
        this.video.removeEventListener('pause', this.onPause);
        this.video.removeEventListener('volumechange', this.onVolume);
      }

      silence() {
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.volume = 0;
      }

      tryPlay() {
        this.silence();
        this.video.preload = 'auto';
        const play = this.video.play();
        if (play && typeof play.catch === 'function') play.catch(() => this.syncUi());
      }

      togglePlay() {
        if (this.video.paused) this.tryPlay();
        else this.video.pause();
      }

      syncUi() {
        const paused = this.video.paused;
        this.classList.toggle('is-paused', paused);
        this.classList.toggle('is-playing', !paused);

        this.querySelectorAll('[data-icon-play]').forEach((el) => {
          el.hidden = !paused;
        });
        this.querySelectorAll('[data-icon-pause]').forEach((el) => {
          el.hidden = paused;
        });
        this.toggles.forEach((btn) => {
          btn.setAttribute('aria-label', paused ? this.labels.play : this.labels.pause);
        });
      }
    }

    if (!customElements.get('manufacture-film')) {
      customElements.define('manufacture-film', ManufactureFilm);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["philosophy"] && !Shopify.designMode) return;
  try {
    
  class PhilosophyCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('.philosophy-carousel__slide'));
      this.dotsHost = this.querySelector('[data-dots]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');

      this.slides.forEach((slide) => {
        slide.addEventListener('click', (event) => {
          if (this.moved) {
            event.preventDefault();
            event.stopPropagation();
            this.moved = false;
            return;
          }
          this.toggleActive(slide);
        });
        slide.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.toggleActive(slide);
          }
        });
      });

      if (!this.track || this.slides.length < 2) {
        this.classList.add('is-single');
        return;
      }

      this.dotsHost.replaceChildren();
      this.dots = this.slides.map((_, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'philosophy-carousel__dot';
        btn.setAttribute('aria-label', String(i + 1));
        btn.addEventListener('click', () => this.go(i));
        this.dotsHost.appendChild(btn);
        return btn;
      });

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      this.bindSwipe();
      window.addEventListener('resize', () => this.sync(), { passive: true });
      this.sync();
    }

    bindSwipe() {
      if (!this.track || this.track.dataset.nyfSwipe) return;
      this.track.dataset.nyfSwipe = '1';
      this.track.addEventListener('pointerdown', (event) => this.onPointerDown(event));
      this.track.addEventListener('pointermove', (event) => this.onPointerMove(event));
      this.track.addEventListener('pointerup', (event) => this.onPointerUp(event));
      this.track.addEventListener('pointercancel', (event) => this.onPointerUp(event));
    }

    onPointerDown(event) {
      if (event.pointerType === 'touch') return;
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.moved = false;
      this.axis = null;
    }

    onPointerMove(event) {
      if (this.startX == null) return;
      const dx = event.clientX - this.startX;
      const dy = event.clientY - this.startY;
      if (this.axis == null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
        this.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (this.axis === 'x') this.moved = true;
    }

    onPointerUp(event) {
      if (this.axis === 'x' && this.startX != null) {
        const dx = event.clientX - this.startX;
        if (dx <= -40) this.step(1);
        else if (dx >= 40) this.step(-1);
      }
      this.startX = null;
      this.startY = null;
      this.axis = null;
    }

    slideWidth() {
      const first = this.slides[0];
      if (!first) return 0;
      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    currentIndex() {
      const width = this.slideWidth();
      if (!width) return 0;
      return Math.round(this.track.scrollLeft / width);
    }

    maxIndex() {
      const width = this.slideWidth();
      if (!width) return 0;
      const extra = this.track.scrollWidth - this.track.clientWidth;
      return Math.max(0, Math.round(extra / width));
    }

    go(index) {
      const width = this.slideWidth();
      const next = Math.max(0, Math.min(this.maxIndex(), index));
      this.track.scrollTo({ left: next * width, behavior: 'smooth' });
    }

    step(dir) {
      this.go(this.currentIndex() + dir);
    }

    toggleActive(slide) {
      const active = slide.classList.toggle('is-active');
      slide.setAttribute('aria-pressed', String(active));
      this.slides.forEach((other) => {
        if (other !== slide) {
          other.classList.remove('is-active');
          other.setAttribute('aria-pressed', 'false');
        }
      });
    }

    sync() {
      const index = this.currentIndex();
      const max = this.maxIndex();
      this.dots.forEach((dot, i) => dot.classList.toggle('is-on', i === index));
      if (this.prevBtn) this.prevBtn.disabled = index <= 0;
      if (this.nextBtn) this.nextBtn.disabled = index >= max;
    }
  }

  if (!customElements.get('philosophy-carousel')) {
    customElements.define('philosophy-carousel', PhilosophyCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-fbt"] && !Shopify.designMode) return;
  try {
    
  function formatFbtMoney(cents, format) {
    const amount = (Number(cents) / 100).toFixed(2);
    const whole = String(Math.round(Number(cents) / 100));
    if (!format) return 'Rs. ' + amount;
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function bindFbt(root) {
    const discount = Number(root.dataset.discount || 0);
    const format = root.dataset.moneyFormat || '';
    const compareEl = root.querySelector('[data-fbt-compare]');
    const nowEl = root.querySelector('[data-fbt-now]');
    const saveEl = root.querySelector('[data-fbt-save]');
    const addBtn = root.querySelector('[data-fbt-add]');
    if (!addBtn) return;

    const selectedItems = () =>
      Array.from(root.querySelectorAll('[data-fbt-item]')).filter((input) => {
        return input.checked && input.dataset.available !== 'false';
      });

    const sync = () => {
      root.querySelectorAll('.fbt-line').forEach((row) => {
        const input = row.querySelector('[data-fbt-item]');
        row.classList.toggle('is-on', !!(input && input.checked));
      });

      const picked = selectedItems();
      let compare = 0;
      let sale = 0;
      picked.forEach((input) => {
        compare += Number(input.dataset.compare || 0);
        sale += Number(input.dataset.price || 0);
      });
      let now = sale;
      if (discount > 0 && picked.length > 1) {
        now = Math.round(sale * (100 - discount) / 100);
      }
      if (compareEl) {
        if (compare > now) {
          compareEl.hidden = false;
          compareEl.textContent = formatFbtMoney(compare, format);
        } else {
          compareEl.hidden = true;
          compareEl.textContent = '';
        }
      }
      if (nowEl) nowEl.textContent = formatFbtMoney(now, format);
      if (saveEl) {
        if (compare > now && compare > 0) {
          const pct = Math.round(((compare - now) * 100) / compare);
          saveEl.hidden = false;
          saveEl.textContent = (root.dataset.textSave || 'Save __PCT__%').replace('__PCT__', String(pct));
        } else {
          saveEl.hidden = true;
          saveEl.textContent = '';
        }
      }
      addBtn.disabled = picked.length === 0;
    };

    root.addEventListener('change', (event) => {
      if (event.target && event.target.hasAttribute('data-fbt-item')) sync();
    });

    addBtn.addEventListener('click', async () => {
      const picked = selectedItems();
      if (!picked.length || addBtn.disabled) return;

      const items = picked.map((input) => ({
        id: Number(input.dataset.id),
        quantity: 1,
      }));

      addBtn.disabled = true;
      addBtn.classList.add('is-busy');

      const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const drawer = document.querySelector('cart-drawer');

      try {
        if (root.dataset.discountCode) {
          try {
            await fetch(rootUrl + 'discount/' + encodeURIComponent(root.dataset.discountCode), {
              credentials: 'same-origin',
            });
          } catch (err) {
            /* code apply is optional */
          }
        }

        const res = await fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: items,
            sections: 'cart-drawer',
          }),
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || 'cart error');

        if (drawer && typeof drawer.renderSection === 'function') {
          drawer.renderSection(data.sections && data.sections['cart-drawer']);
          drawer.open();
        }
        if (window.nyfPixel && typeof window.nyfPixel.addToCart === 'function') {
          window.nyfPixel.addToCart(data);
        }
        window.themeToast && window.themeToast(root.dataset.textAdded || 'Bundle added to cart');
      } catch (err) {
        window.themeToast && window.themeToast(root.dataset.textError || 'Something went wrong');
      } finally {
        addBtn.classList.remove('is-busy');
        addBtn.disabled = false;
        sync();
      }
    });

    sync();
  }

  document.querySelectorAll('[data-fbt]').forEach(bindFbt);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  class ProductCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('.prod-carousel__slide'));
      this.dotsHost = this.querySelector('[data-dots]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      if (!this.track || this.slides.length < 1) return;

      if (this.slides.length < 2) {
        this.classList.add('is-single');
        return;
      }

      this.dots = this.slides.map((_, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'prod-carousel__dot';
        btn.setAttribute('aria-label', String(i + 1));
        btn.addEventListener('click', () => this.go(i));
        this.dotsHost.appendChild(btn);
        return btn;
      });

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      window.addEventListener('resize', () => this.sync(), { passive: true });
      this.sync();
    }

    slideWidth() {
      const first = this.slides[0];
      if (!first) return 0;
      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    currentIndex() {
      const width = this.slideWidth();
      if (!width) return 0;
      return Math.round(this.track.scrollLeft / width);
    }

    maxIndex() {
      const width = this.slideWidth();
      if (!width) return 0;
      const extra = this.track.scrollWidth - this.track.clientWidth;
      return Math.max(0, Math.round(extra / width));
    }

    go(index) {
      const width = this.slideWidth();
      const next = Math.max(0, Math.min(this.maxIndex(), index));
      this.track.scrollTo({ left: next * width, behavior: 'smooth' });
    }

    step(dir) {
      this.go(this.currentIndex() + dir);
    }

    sync() {
      const index = this.currentIndex();
      const max = this.maxIndex();
      this.dots.forEach((dot, i) => dot.classList.toggle('is-on', i === index));
      if (this.prevBtn) this.prevBtn.disabled = index <= 0;
      if (this.nextBtn) this.nextBtn.disabled = index >= max;
    }
  }

  if (!customElements.get('product-carousel')) {
    customElements.define('product-carousel', ProductCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredients"] && !Shopify.designMode) return;
  try {
    
  class IngredientCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dotsHost = this.querySelector('[data-dots]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      if (!this.track || this.slides.length < 1) return;

      this.dots = this.slides.map((_, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'p-ing-dot';
        btn.setAttribute('aria-label', String(i + 1));
        btn.addEventListener('click', () => this.go(i));
        this.dotsHost.appendChild(btn);
        return btn;
      });

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      this.sync();
    }

    slideWidth() {
      const first = this.slides[0];
      if (!first) return 0;
      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    currentIndex() {
      const width = this.slideWidth();
      if (!width) return 0;
      return Math.round(this.track.scrollLeft / width);
    }

    go(index) {
      const width = this.slideWidth();
      const max = this.slides.length - 1;
      const next = Math.max(0, Math.min(max, index));
      this.track.scrollTo({ left: next * width, behavior: 'smooth' });
    }

    step(dir) {
      this.go(this.currentIndex() + dir);
    }

    sync() {
      const index = this.currentIndex();
      this.dots.forEach((dot, i) => dot.classList.toggle('is-on', i === index));
    }
  }

  if (!customElements.get('ingredient-carousel')) {
    customElements.define('ingredient-carousel', IngredientCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-transformations"] && !Shopify.designMode) return;
  try {
    
  class TransformationCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dotsHost = this.querySelector('[data-dots]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      if (!this.track || this.slides.length < 1) return;

      this.dots = this.slides.map((_, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'p-xform-dot';
        btn.setAttribute('aria-label', String(i + 1));
        btn.addEventListener('click', () => this.go(i));
        this.dotsHost.appendChild(btn);
        return btn;
      });

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      this.sync();
    }

    slideWidth() {
      const first = this.slides[0];
      if (!first) return 0;
      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    currentIndex() {
      const width = this.slideWidth();
      if (!width) return 0;
      return Math.round(this.track.scrollLeft / width);
    }

    go(index) {
      const width = this.slideWidth();
      const max = this.slides.length - 1;
      const next = Math.max(0, Math.min(max, index));
      this.track.scrollTo({ left: next * width, behavior: 'smooth' });
    }

    step(dir) {
      this.go(this.currentIndex() + dir);
    }

    sync() {
      const index = this.currentIndex();
      this.dots.forEach((dot, i) => dot.classList.toggle('is-on', i === index));
    }
  }

  if (!customElements.get('transformation-carousel')) {
    customElements.define('transformation-carousel', TransformationCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-goto]'));
      this.index = 0;
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.go(Number(thumb.dataset.goto)));
      });
      this.bindSwipe();
      this.go(0);
    }

    go(next) {
      if (!this.slides.length || !this.track) return;
      const total = this.slides.length;
      this.index = (next + total) % total;
      this.track.style.transform = 'translateX(-' + this.index * 100 + '%)';
      this.slides.forEach((slide, i) => slide.classList.toggle('is-on', i === this.index));
      this.thumbs.forEach((thumb, i) => thumb.classList.toggle('is-on', i === this.index));
    }

    bindSwipe() {
      const stage = this.querySelector('.pdp-slides');
      if (!stage) return;
      let startX = 0;
      let delta = 0;
      let dragging = false;
      stage.addEventListener('pointerdown', (e) => {
        dragging = true;
        startX = e.clientX;
        delta = 0;
        stage.setPointerCapture(e.pointerId);
      });
      stage.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        delta = e.clientX - startX;
      });
      const end = () => {
        if (!dragging) return;
        dragging = false;
        if (delta > 40) this.go(this.index - 1);
        if (delta < -40) this.go(this.index + 1);
      };
      stage.addEventListener('pointerup', end);
      stage.addEventListener('pointercancel', end);
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }

  function formatPdpMoney(cents, format) {
    const value = Number(cents) / 100;
    if (Number.isNaN(value)) return '';
    const amount = value.toFixed(2);
    const parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const pretty = parts.join('.');
    if (!format) return 'Rs. ' + pretty;
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/g, pretty);
  }

  const NYF_COUPON_KEY = 'nyf:pdp-coupon';
  const NYF_COUPON_PCT_KEY = 'nyf:pdp-coupon-percent';

  function savedCouponPercent() {
    try {
      const code = (sessionStorage.getItem(NYF_COUPON_KEY) || '').trim();
      const percent = Number(sessionStorage.getItem(NYF_COUPON_PCT_KEY) || 0);
      if (!code || !(percent > 0)) return 0;
      return percent;
    } catch (err) {
      return 0;
    }
  }

  function savedCouponCode() {
    try {
      return (sessionStorage.getItem(NYF_COUPON_KEY) || '').trim();
    } catch (err) {
      return '';
    }
  }

  function cartUnitPrices(info) {
    const map = {};
    const raw = info && info.dataset.cartUnits ? info.dataset.cartUnits : '';
    raw.split(',').forEach((row) => {
      if (!row) return;
      const parts = row.split(':');
      if (parts.length < 3) return;
      map[parts[0]] = {
        original: Number(parts[1]) || 0,
        final: Number(parts[2]) || 0,
      };
    });
    return map;
  }

  function packPrice(input, info) {
    const listCents = Number(input.dataset.priceCents || 0);
    const compareCents = Number(input.dataset.compareCents || 0);
    const offerPct = Number(info.dataset.offerPercent || 40);
    const couponPct = Number(info.dataset.couponPercent || 0) || savedCouponPercent();
    const line = cartUnitPrices(info)[String(input.value)];
    if (line && line.original > 0 && line.final < line.original) {
      return {
        now: line.final,
        strike: line.original,
        save: Math.round(((line.original - line.final) * 100) / line.original),
      };
    }
    if (couponPct > 0 && listCents > 0) {
      return {
        now: Math.round((listCents * (100 - couponPct)) / 100),
        strike: listCents,
        save: couponPct,
      };
    }
    const markedCents = Math.round((listCents * 100) / (100 - offerPct));
    return {
      now: listCents,
      strike: Math.max(compareCents, markedCents),
      save: offerPct,
    };
  }

  function bindProductBuy(form) {
    if (!form || form.dataset.pdpBound) return;
    form.dataset.pdpBound = 'true';
    const info = form.closest('.pdp-info');
    if (!info) return;
    const addBtn = form.querySelector('[data-pdp-add]');
    const nowEl = info.querySelector('[data-pdp-now]');
    const compareEl = info.querySelector('[data-pdp-compare]');
    const saveEl = info.querySelector('[data-pdp-save]');
    const qtyBox = form.querySelector('[data-pdp-qty]');
    const qtyInput = qtyBox ? qtyBox.querySelector('input') : null;

    const applyPack = (input) => {
      if (!input) return;
      form.querySelectorAll('.pdp-pack').forEach((label) => {
        label.classList.toggle('is-on', label.contains(input));
      });
      const format = info.dataset.moneyFormat || '';
      const priced = packPrice(input, info);
      if (nowEl) {
        if (priced.now > 0) nowEl.textContent = formatPdpMoney(priced.now, format);
        else if (priced.strike > 0) nowEl.textContent = formatPdpMoney(0, format);
        else if (input.dataset.price) nowEl.textContent = input.dataset.price;
      }
      if (compareEl) {
        if (priced.strike > priced.now && priced.now >= 0 && priced.strike > 0) {
          compareEl.textContent = formatPdpMoney(priced.strike, format);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (saveEl) {
        const showSave = priced.strike > priced.now && priced.save > 0;
        saveEl.hidden = !showSave;
        if (showSave) {
          saveEl.textContent = (info.dataset.saveTemplate || 'Save PERCENT%').replace('PERCENT', String(priced.save));
        }
      }
      if (addBtn) addBtn.disabled = input.dataset.available === 'false';
      const pack = input.dataset.pack;
      const pdp = form.closest('.pdp');
      if (pdp && pack) {
        const galleries = Array.from(pdp.querySelectorAll('[data-gallery-pack]'));
        const onlyOne = galleries.length < 2;
        galleries.forEach((gallery) => {
          const on = onlyOne || gallery.dataset.galleryPack === pack;
          gallery.hidden = !on;
          gallery.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (on && typeof gallery.go === 'function') gallery.go(0);
        });
      }
    };

    form.querySelectorAll('input[data-pack]').forEach((input) => {
      input.addEventListener('change', () => applyPack(input));
    });
    applyPack(form.querySelector('input[data-pack]:checked'));

    info.addEventListener('nyf:coupon-applied', () => {
      applyPack(form.querySelector('input[data-pack]:checked'));
    });
    info.addEventListener('nyf:coupon-removed', () => {
      applyPack(form.querySelector('input[data-pack]:checked'));
    });
  }

  document.querySelectorAll('form.pdp-form').forEach(bindProductBuy);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty]');
    if (!btn) return;
    const box = btn.closest('[data-pdp-qty]');
    if (!box) return;
    const input = box.querySelector('input');
    if (!input) return;
    e.preventDefault();
    const next = parseInt(input.value, 10) || 1;
    input.value = String(Math.max(1, next + Number(btn.dataset.qty)));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('input', (e) => {
    if (!e.target.matches('[data-pdp-qty] input')) return;
    const digits = e.target.value.replace(/[^\d]/g, '');
    e.target.value = digits === '' ? '' : String(Math.max(1, parseInt(digits, 10)));
  });

  document.addEventListener('blur', (e) => {
    if (!e.target.matches('[data-pdp-qty] input')) return;
    if (!e.target.value) e.target.value = '1';
  }, true);

  function bindPincode(box) {
    if (!box || box.dataset.bound) return;
    box.dataset.bound = 'true';
    const input = box.querySelector('[data-pin-input]');
    const button = box.querySelector('[data-pin-check]');
    const result = box.querySelector('[data-pin-result]');
    if (!input || !button || !result) return;

    const show = (text, bad) => {
      result.hidden = false;
      result.textContent = text;
      result.classList.toggle('is-bad', !!bad);
    };

    const check = async () => {
      const pin = (input.value || '').replace(/\D/g, '');
      input.value = pin;
      if (!/^\d{6}$/.test(pin)) {
        show(box.dataset.msgInvalid || 'Enter a valid 6-digit pincode', true);
        return;
      }
      button.disabled = true;
      try {
        const res = await fetch('https://api.postalpincode.in/pincode/' + pin);
        const data = await res.json();
        const office = data && data[0] && data[0].PostOffice && data[0].PostOffice[0];
        if (office && office.District) {
          const place = office.Name ? office.Name + ', ' + office.District : office.District;
          show((box.dataset.msgOk || 'Yes, we deliver to __PLACE__.').replace('__PLACE__', place), false);
        } else {
          show(box.dataset.msgFail || 'We could not confirm that pincode. Try again.', true);
        }
      } catch (err) {
        show(box.dataset.msgFail || 'We could not confirm that pincode. Try again.', true);
      } finally {
        button.disabled = false;
      }
    };

    button.addEventListener('click', check);
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        check();
      }
    });
  }

  document.querySelectorAll('[data-pincode]').forEach(bindPincode);

  const NYF_COUPON_ATTEMPT_KEY = 'nyf:coupon-attempt';

  function readCouponOffer(cart, variantId, code) {
    const wanted = String(code || '').trim().toUpperCase();
    const codes = cart.discount_codes || [];
    let rejected = false;
    let seen = false;
    for (let i = 0; i < codes.length; i += 1) {
      if (String(codes[i].code || '').trim().toUpperCase() !== wanted) continue;
      seen = true;
      rejected = codes[i].applicable === false;
    }
    const apps = []
      .concat(cart.cart_level_discount_applications || [])
      .concat(cart.discount_applications || []);
    for (let i = 0; i < apps.length; i += 1) {
      const app = apps[i];
      const type = String(app.value_type || '').toLowerCase();
      const value = parseFloat(app.value);
      if (type === 'percentage' && value > 0 && value <= 100) {
        return { rejected: false, percent: Math.round(value) };
      }
    }
    const items = cart.items || [];
    let line = null;
    for (let i = 0; i < items.length; i += 1) {
      if (String(items[i].variant_id) === String(variantId)) line = items[i];
    }
    if (!line && items.length) line = items[0];
    if (line) {
      const original = Number(line.original_line_price || line.original_price || 0);
      const finalPrice = Number(line.final_line_price || line.final_price || 0);
      const lineDiscount = Number(line.total_discount || 0);
      if (original > 0 && lineDiscount > 0) {
        return { rejected: false, percent: Math.round((lineDiscount * 100) / original) };
      }
      if (original > 0 && finalPrice > 0 && finalPrice < original) {
        return { rejected: false, percent: Math.round(((original - finalPrice) * 100) / original) };
      }
    }
    const cartOriginal = Number(cart.original_total_price || 0);
    const cartDiscount = Number(cart.total_discount || 0);
    if (cartOriginal > 0 && cartDiscount > 0) {
      return { rejected: false, percent: Math.round((cartDiscount * 100) / cartOriginal) };
    }
    if (rejected) return { rejected: true, percent: 0 };
    if (seen) return { rejected: false, percent: 0 };
    return { rejected: false, percent: 0 };
  }

  async function quoteCoupon(root, code, variantId) {
    let probedId = '';
    try {
      const cartRes = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!cartRes.ok) return { checked: false, percent: 0 };
      const cart = await cartRes.json();
      if (!cart.items || !cart.items.length) {
        const addRes = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        if (!addRes.ok) return { checked: false, percent: 0 };
        probedId = variantId;
      }
      const updateRes = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code }),
      });
      if (!updateRes.ok) return { checked: false, percent: 0 };
      const updated = await updateRes.json();
      const offer = readCouponOffer(updated, variantId, code);
      if (offer.rejected) {
        try {
          await fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: '' }),
          });
        } catch (err) {
          /* Shopify already refused the code */
        }
        return { checked: true, rejected: true, percent: 0 };
      }
      return { checked: true, rejected: false, percent: offer.percent };
    } catch (err) {
      return { checked: false, percent: 0 };
    } finally {
      if (probedId) {
        try {
          await fetch(root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: probedId, quantity: 0 }),
          });
        } catch (err) {
          /* the probe line is removed on the next cart refresh */
        }
      }
    }
  }

  function showAppliedChip(info, code) {
    if (!info || !code) return;
    const chip = info.querySelector('[data-pdp-coupon-chip]');
    const text = chip ? chip.querySelector('[data-pdp-coupon-chip-text]') : null;
    if (!chip || !text) return;
    const template = info.dataset.couponAppliedLabel || '__CODE__ applied';
    text.textContent = template.replace('__CODE__', String(code).toUpperCase());
    chip.hidden = false;
  }

  function refreshProductPrices() {
    document.querySelectorAll('form.pdp-form').forEach((form) => {
      const selected = form.querySelector('input[data-pack]:checked') || form.querySelector('input[data-pack]');
      if (!selected) return;
      selected.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function goToDiscount(root, code, redirect, storeHost) {
    try {
      sessionStorage.setItem(NYF_COUPON_ATTEMPT_KEY, code);
    } catch (err) {
      /* sessionStorage unavailable, continue without feedback */
    }
    const path = 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);
    const local = location.hostname === '127.0.0.1' || location.hostname === 'localhost';
    if (local && storeHost) {
      window.location.href = 'https://' + storeHost + '/' + path;
      return;
    }
    window.location.href = root + path;
  }

  function bindCoupon(box) {
    if (!box || box.dataset.bound) return;
    box.dataset.bound = 'true';
    const toggle = box.querySelector('[data-pdp-coupon-toggle]');
    const form = box.querySelector('[data-pdp-coupon-form]');
    const input = box.querySelector('[data-pdp-coupon-input]');
    const applyBtn = box.querySelector('[data-pdp-coupon-apply]');
    const msg = box.querySelector('[data-pdp-coupon-msg]');
    if (!form || !input) return;

    const showMsg = (text, bad) => {
      if (!msg) return;
      msg.hidden = false;
      msg.textContent = text;
      msg.classList.toggle('is-bad', !!bad);
    };

    if (toggle) {
      toggle.addEventListener('click', () => {
        toggle.hidden = true;
        form.hidden = false;
        input.focus();
      });
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const code = input.value.trim();
      if (!code) {
        showMsg(box.dataset.msgEmpty || 'Enter a coupon code', true);
        return;
      }
      if (applyBtn) applyBtn.disabled = true;
      showMsg(box.dataset.msgApplying || 'Applying coupon…', false);
      const info = box.closest('.pdp-info');
      const selected = info
        ? info.querySelector('input[data-pack]:checked') || info.querySelector('input[name="id"]')
        : null;
      const variantId = selected ? selected.value : '';
      const redirect = form.dataset.redirect || window.location.pathname;
      const root = box.dataset.root || '/';
      const quote = variantId ? await quoteCoupon(root, code, variantId) : { checked: false, rejected: false, percent: 0 };
      if (quote.rejected) {
        if (applyBtn) applyBtn.disabled = false;
        showMsg(box.dataset.msgInvalid || 'That coupon code is invalid or expired.', true);
        return;
      }
      if (!(quote.percent > 0)) {
        goToDiscount(root, code, redirect, box.dataset.storeHost || '');
        return;
      }
      const percent = quote.percent;
      const displayCode = code.toUpperCase();
      if (window.nyfCoupon && typeof window.nyfCoupon.set === 'function') {
        window.nyfCoupon.set(displayCode, percent);
      } else {
        try {
          sessionStorage.setItem(NYF_COUPON_KEY, displayCode);
          sessionStorage.setItem(NYF_COUPON_PCT_KEY, String(percent));
        } catch (err) {
          /* the redirect still stores the code with Shopify */
        }
      }
      showAppliedChip(info, displayCode);
      refreshProductPrices();
      goToDiscount(root, code, redirect, box.dataset.storeHost || '');
    });
  }

  document.querySelectorAll('[data-pdp-coupon]').forEach(bindCoupon);

  function bindFirstOrderCoupon(box) {
    if (!box || box.dataset.bound) return;
    box.dataset.bound = 'true';
    const btn = box.querySelector('[data-pdp-first-order-apply]');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const code = box.dataset.code;
      if (!code) return;
      btn.disabled = true;
      btn.textContent = box.dataset.msgApplying || 'Applying…';
      const redirect = box.dataset.redirect || window.location.pathname;
      const root = box.dataset.root || '/';
      goToDiscount(root, code, redirect, box.dataset.storeHost || '');
    });
  }

  document.querySelectorAll('[data-pdp-first-order]').forEach(bindFirstOrderCoupon);

  function showCouponToast(info) {
    if (!info) return;
    let attempted = null;
    try {
      attempted = sessionStorage.getItem(NYF_COUPON_ATTEMPT_KEY);
      if (attempted) sessionStorage.removeItem(NYF_COUPON_ATTEMPT_KEY);
    } catch (err) {
      return;
    }
    if (!attempted) return;
    const toast = info.querySelector('[data-pdp-coupon-toast]');
    if (!toast) return;
    const titles = (info.dataset.cartDiscountTitles || '').split('|').filter(Boolean);
    const itemCount = parseInt(info.dataset.cartItemCount || '0', 10);
    const savedCode = savedCouponCode();
    const savedPercent = savedCouponPercent();
    if (titles.length > 0 || savedPercent > 0) {
      toast.hidden = true;
      showAppliedChip(info, savedCode || titles[0]);
      const entry = info.querySelector('[data-pdp-coupon]');
      if (entry) entry.hidden = true;
      refreshProductPrices();
    } else if (itemCount === 0) {
      toast.hidden = false;
      toast.classList.remove('is-bad');
      toast.textContent = toast.dataset.msgPending || 'Code saved — add an item to your cart and it will apply at checkout.';
    } else {
      toast.hidden = true;
    }
  }

  document.querySelectorAll('[data-pdp-info]').forEach((info) => {
    const savedCode = savedCouponCode();
    if (savedCode && savedCouponPercent() > 0) {
      showAppliedChip(info, savedCode);
      const entry = info.querySelector('[data-pdp-coupon]');
      if (entry) entry.hidden = true;
    }
    showCouponToast(info);
  });

  function bindAskAi(root) {
    if (!root || root.dataset.bound) return;
    root.dataset.bound = 'true';
    const form = root.querySelector('[data-ask-ai-form]');
    const input = root.querySelector('.pdp-ask-ai-input');
    const chips = root.querySelectorAll('[data-ask-ai-chip]');

    const ask = (question) => {
      const text = (question || '').trim();
      if (!text) return;
      window.dispatchEvent(new CustomEvent('nyf:ask-ai', { detail: { question: text } }));
    };

    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        ask(input ? input.value : '');
        if (input) input.value = '';
      });
    }

    chips.forEach((chip) => {
      chip.addEventListener('click', () => ask(chip.textContent));
    });
  }

  document.querySelectorAll('[data-ask-ai]').forEach(bindAskAi);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class ReviewCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dotsHost = this.querySelector('[data-dots]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      if (!this.track || this.slides.length < 1) return;

      this.dots = this.slides.map((_, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rev-dot';
        btn.setAttribute('aria-label', String(i + 1));
        btn.addEventListener('click', () => this.go(i));
        this.dotsHost.appendChild(btn);
        return btn;
      });

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      this.sync();
    }

    slideWidth() {
      const first = this.slides[0];
      if (!first) return 0;
      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    currentIndex() {
      const width = this.slideWidth();
      if (!width) return 0;
      return Math.round(this.track.scrollLeft / width);
    }

    go(index) {
      const width = this.slideWidth();
      const max = this.slides.length - 1;
      const next = Math.max(0, Math.min(max, index));
      this.track.scrollTo({ left: next * width, behavior: 'smooth' });
    }

    step(dir) {
      this.go(this.currentIndex() + dir);
    }

    sync() {
      const index = this.currentIndex();
      this.dots.forEach((dot, i) => dot.classList.toggle('is-on', i === index));
    }
  }

  if (!customElements.get('review-carousel')) {
    customElements.define('review-carousel', ReviewCarousel);
  }

  function bindReviewQuotes() {
    document.querySelectorAll('.rev').forEach((card) => {
      if (card.dataset.quoteBound) return;
      const quote = card.querySelector('.rev-quote');
      const btn = card.querySelector('[data-rev-more]');
      if (!quote || !btn) return;
      card.dataset.quoteBound = 'true';
      const more = btn.getAttribute('data-more') || 'Read more';
      const less = btn.getAttribute('data-less') || 'Show less';
      if (quote.scrollHeight <= quote.clientHeight + 4) {
        btn.hidden = true;
        return;
      }
      btn.addEventListener('click', () => {
        const open = card.classList.toggle('is-open');
        btn.textContent = open ? less : more;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  bindReviewQuotes();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-scrub-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp01 = (x) => (x < 0 ? 0 : x > 1 ? 1 : x);
    const FALLBACK_DURATION = 5.33;

    class ScrubHero extends HTMLElement {
      connectedCallback() {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const anims = document.documentElement.classList.contains('anims');
        this.video = this.querySelector('video');
        if (reduce || !anims || !this.video) return;

        this.classList.add('is-scrub');
        this.duration = FALLBACK_DURATION;
        this.mobile = window.matchMedia('(max-width: 767px)');
        this.intro = this.querySelector('[data-vsh-intro]');
        this.content = this.querySelector('[data-vsh-content]');
        this.cta = this.querySelector('[data-vsh-cta]');
        this.cue = this.querySelector('[data-vsh-cue]');
        this.botanicals = Array.from(this.querySelectorAll('[data-vsh-botanical]'));
        this.ticking = false;

        this.video.muted = true;
        this.video.addEventListener('loadedmetadata', () => {
          if (this.video.duration && isFinite(this.video.duration)) {
            this.duration = this.video.duration;
          }
          if (this.onScroll) this.onScroll();
        });
        this.initFilm();

        this.onScroll = () => {
          if (!this.ticking) {
            this.ticking = true;
            requestAnimationFrame(() => this.update());
          }
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.onScroll();
      }

      // Scrubbing needs every frame to be instantly seekable, but seeking a
      // streamed video depends on HTTP range requests - which some servers
      // (notably the `shopify theme dev` local proxy) don't support, leaving
      // the video stuck at readyState 0 with every seek silently dropped.
      // Fetching the film once and playing it from a blob: URL takes the
      // network out of seeking entirely: reliable on the dev proxy, and
      // smoother scrubbing against the CDN in production.
      async initFilm() {
        const src = this.video.currentSrc || this.video.src;
        try {
          const res = await fetch(src);
          if (!res.ok) throw new Error(res.status);
          const blob = await res.blob();
          this.objectUrl = URL.createObjectURL(blob);
          this.video.src = this.objectUrl;
        } catch (e) {
          // Blob fetch failed - fall back to native streaming.
        }
        // Force the load: iOS never fetches metadata for preload="none"
        // media on its own, and without metadata every seek is dropped.
        this.video.preload = 'auto';
        this.video.load();
        await this.prime();
        try { this.video.currentTime = 0.001; } catch (e) { /* not ready yet */ }
        if (this.onScroll) this.onScroll();
      }

      // iOS only paints video frames after playback has started once, so a
      // muted inline play()+pause() unlocks frame-accurate seeking. When
      // autoplay is rejected (e.g. Low Power Mode blocks even muted
      // autoplay), retry inside the first touch gesture - scrolling starts
      // with one, so the film unlocks on the first scrub.
      async prime() {
        this.video.defaultMuted = true;
        this.video.muted = true;
        try {
          await this.video.play();
          this.video.pause();
        } catch (e) {
          this.onGesture = () => {
            this.removeGestureListeners();
            this.video.play().then(() => {
              this.video.pause();
              if (this.onScroll) this.onScroll();
            }).catch(() => {});
          };
          window.addEventListener('touchend', this.onGesture, { passive: true });
          window.addEventListener('click', this.onGesture);
        }
      }

      removeGestureListeners() {
        if (!this.onGesture) return;
        window.removeEventListener('touchend', this.onGesture);
        window.removeEventListener('click', this.onGesture);
        this.onGesture = null;
      }

      disconnectedCallback() {
        if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
        this.removeGestureListeners();
        if (!this.onScroll) return;
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      update() {
        this.ticking = false;
        const rect = this.getBoundingClientRect();
        const range = rect.height - window.innerHeight;
        const p = range > 0 ? clamp01(-rect.top / range) : 0;

        // Scrub the film. fastSeek (Safari) avoids seek-queue stalls during
        // a drag; the film is encoded all-keyframe so it stays accurate.
        // Seeking before HAVE_METADATA throws on Safari (fastSeek) and is
        // dropped elsewhere - skip it so the copy choreography below always
        // runs, even while the film is still loading or autoplay-blocked.
        const t = Math.min(this.duration - 0.02, Math.max(0, p * this.duration));
        if (this.video.readyState > 0 && Math.abs(this.video.currentTime - t) > 0.015) {
          try {
            if (typeof this.video.fastSeek === 'function') this.video.fastSeek(t);
            else this.video.currentTime = t;
          } catch (e) { /* mid-load edge; next scroll frame retries */ }
        }

        // On mobile, glide the frame left mid-scroll so the growing pouch
        // clears the copy column.
        if (this.mobile.matches) {
          const shiftX = 50 + clamp01((p - 0.12) / 0.6) * 34;
          this.video.style.objectPosition = shiftX + '% bottom';
        } else if (this.video.style.objectPosition) {
          this.video.style.objectPosition = '';
        }

        // Copy choreography (same curves as the reference).
        const introT = 1 - clamp01(p / 0.16);
        this.setStyles(this.intro, introT, 'translateY(' + (-(1 - introT) * 10).toFixed(1) + 'px)');

        const headT = clamp01((p - 0.1) / 0.14);
        this.setStyles(this.content, headT, 'translateY(' + ((1 - headT) * 12).toFixed(1) + 'px)');

        this.botanicals.forEach((li, i) => {
          const bt = clamp01((p - (0.3 + i * 0.1)) / 0.08);
          this.setStyles(li, bt, 'translateX(' + ((1 - bt) * 22).toFixed(1) + 'px)');
        });

        if (this.cta) {
          const ctaT = clamp01((p - 0.82) / 0.12);
          this.setStyles(this.cta, ctaT, 'translateY(' + ((1 - ctaT) * 16).toFixed(1) + 'px)');
        }
        if (this.cue) {
          this.cue.style.opacity = (1 - clamp01(p / 0.1)).toFixed(3);
        }
      }

      setStyles(el, opacity, transform) {
        if (!el) return;
        el.style.opacity = opacity.toFixed(3);
        el.style.transform = transform;
      }
    }

    if (!customElements.get('scrub-hero')) customElements.define('scrub-hero', ScrubHero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weight-loss-landing"] && !Shopify.designMode) return;
  try {
    
  class WlbGallery extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('.wlb-thumb[data-goto]'));
      this.dots = Array.from(this.querySelectorAll('.wlb-dot[data-goto]'));
      this.index = 0;
      this.timer = null;
      this.thumbs.concat(this.dots).forEach((btn) => {
        btn.addEventListener('click', () => this.go(Number(btn.dataset.goto), true));
      });
      this.bindSwipe();
      this.go(0);
      this.play();
      this.addEventListener('pointerenter', () => this.stop());
      this.addEventListener('pointerleave', () => this.play());
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
        else this.play();
      });
    }

    go(next, fromUser) {
      if (!this.slides.length || !this.track) return;
      const total = this.slides.length;
      this.index = (next + total) % total;
      this.track.style.transform = 'translateX(-' + this.index * 100 + '%)';
      this.slides.forEach((slide, i) => slide.classList.toggle('is-on', i === this.index));
      this.thumbs.forEach((thumb, i) => thumb.classList.toggle('is-on', i === this.index));
      this.dots.forEach((dot, i) => dot.classList.toggle('is-on', i === this.index));
      const activeThumb = this.thumbs[this.index];
      const scroller = this.querySelector('.wlb-thumbs');
      if (activeThumb && scroller) {
        const left = activeThumb.offsetLeft - scroller.clientWidth / 2 + activeThumb.offsetWidth / 2;
        scroller.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
      if (fromUser) this.play();
    }

    disconnectedCallback() {
      this.stop();
    }

    play() {
      this.stop();
      if (this.slides.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = window.setInterval(() => this.go(this.index + 1), 3800);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    bindSwipe() {
      const stage = this.querySelector('.wlb-slides');
      if (!stage) return;
      let startX = 0;
      let delta = 0;
      let dragging = false;
      stage.addEventListener('pointerdown', (e) => {
        dragging = true;
        startX = e.clientX;
        delta = 0;
        this.stop();
        stage.setPointerCapture(e.pointerId);
      });
      stage.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        delta = e.clientX - startX;
      });
      const end = () => {
        if (!dragging) return;
        dragging = false;
        if (delta > 40) this.go(this.index - 1, true);
        else if (delta < -40) this.go(this.index + 1, true);
        else this.play();
      };
      stage.addEventListener('pointerup', end);
      stage.addEventListener('pointercancel', end);
    }
  }

  if (!customElements.get('wlb-gallery')) {
    customElements.define('wlb-gallery', WlbGallery);
  }

  document.querySelectorAll('.wlb-form').forEach((form) => {
    if (form.dataset.wlbBound) return;
    form.dataset.wlbBound = 'true';
    form.querySelectorAll('input[data-pack]').forEach((input) => {
      input.addEventListener('change', () => {
        form.querySelectorAll('.wlb-pack').forEach((label) => {
          label.classList.toggle('is-on', label.contains(input));
        });
      });
    });
  });

  const sticky = document.querySelector('[data-wlb-sticky]');
  const hero = document.querySelector('[data-wlb-hero]');
  if (sticky) {
    if (hero && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          const wide = window.matchMedia('(min-width: 901px)').matches;
          if (wide) {
            sticky.classList.toggle('is-on', entry && !entry.isIntersecting);
          } else {
            sticky.classList.add('is-on');
          }
        },
        { threshold: 0.15 }
      );
      io.observe(hero);
    } else {
      sticky.classList.add('is-on');
    }
  }

  } catch(e) { console.error(e); }
})();
})();
